const saveToken = (token) => {
    localStorage.setItem('token', token);
}
export default saveToken;